import React from "react";

const Header = ({ title }) => {
  return (
    <div className="flex justify-between items-center text-2xl bg-indigo-50 font-semibold p-4">
      <div>{title}</div>
    </div>
  );
};

export default Header;
